<template>
    <section class="login-now" loding="lazy" @click="closeCountryCodeOnOutsideClick">
        <div class="loginInner1">
            <div class="log-logo">
                <img loading="lazy" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="logo" class="logo-login">
            </div>
            <div class="featured-box-login">
                <h1>{{ $t('register-account','Register Account')}} <i class="fas fa-hand-point-down"></i></h1>

                <form class="form-control-head">
                    <div class="input-field">
                        <div class="country-mob">
                            <div class="form_list_select">
                                <div class="country-select-card" ref="countryCodeWrapper">
                                    <div class="country-select" v-if="countryCodeList && countryCodeList[contIndex]" @click="openCountryCode()" :class="{ 'disabled': timerRunning }">
                                        <div class="country-icon">
                                            <img :src="countryCodeList[contIndex]?.flag" alt="India" loading="lazy">
                                        </div>
                                        <div class="country-code">+  {{ countryCodeList[contIndex]?.phonecode }}</div>
                                        <span class="arrowDown"></span>
                                    </div> 
                                    <div class="country-dropdown" :class="checkCountryCodeSelect ? 'open' :''">
                                        <div class="country-list">
                                            <template v-for="(allowedCountry, countryIndex) in countryCodeList">
                                                <div class="country-item" :key="countryIndex"
                                                    v-if="allowedCountry?.phonecode != countryCodeList[contIndex]?.phonecode"
                                                    @click="selectCountryCode(countryIndex,allowedCountry?.phonecode)">
                                                    <div class="country-icon">
                                                        <img :src="allowedCountry?.flag" :alt="allowedCountry.name" loading="lazy">
                                                    </div>
                                                    <div class="country-name">{{ allowedCountry.name }}</div>
                                                    <div class="country-code">+{{ allowedCountry.phonecode }}</div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="form_list_select_div-r">
                                    <input type="tel" class="form-control pr-8" :placeholder="$t('enter-phone-number', 'Enter Mobile Number')+'*'" 
                                        @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999); validate()" 
                                        id="phonenumber" v-model="form.mobileNo" minlength="10" maxlength="10" :disabled="resendOtp && timerRunning" :class="{'pr-10' : (!timerRunning && resendOtp)}">
                                    <div class="mo-number-right" >
                                        <button v-if="!loadingOtp" :disabled="timerRunning" type="button" @click="otpBtnCall()" id="otp-btn" class="sendOtp-btn" :class="{ 'btn-loading': loadingOtp, 'otp-btn' : (!timerRunning && !resendOtp), 'resend-btn' : (!timerRunning && resendOtp) }">
                                            {{ timerRunning ? formatTime(minutes) + ":" + formatTime(seconds) : resendOtp ? $t('resend-otp',"RESEND OTP") : $t('get-otp',"GET OTP") }}
                                        </button>
                                        <div v-if="loadingOtp" class="text-center" id="Otp_loader">
                                            <div class="spinner-border" role="status">
                                                <span class="visually-hidden">{{$t('loading','Loading')}}...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="init.mobile && checkValidation?.mobile?.length > 0" class="thm-error-text">
                            <div v-for="(err, index) in checkValidation?.mobile" :key="index">
                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                            </div>
                        </div>
                        <div v-if="init.mobile && form.mobileNo.length == 10 && !isOtpApiCalled && getOTPmsg && !loadingOtp" class="thm-error-text">
                            <div>
                                <p class="error-text">{{$t('please-click-on-send-otp','Please Click on Get OTP')}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="input-field" v-if="isOtpApiCalled">
                        <div class="input-field-group">
                            <input type="tel" class="form-control" id="inputPassword2" @input="form.otp = $helper.sanitizeNumber(form.otp, 999999); validate()"
                            :placeholder="$t('enter-otp','Enter OTP')+'*'" v-model="form.otp" maxlength="6" />
                            <div class="input-group-icon"><i class="fas fa-key"></i></div>
                        </div>
                        <!-- errors -->
                        <div v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0" class="thm-error-text">
                            <div v-for="(err, index) in checkValidation?.otp" :key="index">
                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="refer-code-hyper" v-if ="!isSetUserId &&  !isRefral">
                        <a href="javascript:void(0)" @click="isSetUserId =! isSetUserId">{{$t('set-user-id','Want to set UserID')}}?</a>
                    </div>

                    <div class="input-field" v-if ="isSetUserId || isRefral">
                        <div class="input-field-group">
                            <input type="test" maxlength="25" class="form-control" id="inputPassword2" 
                            @input="form.userName = $helper.sanitizeDetails('userId', form.userName); validate()"
                            :placeholder="$t('enter-user-id','Enter User ID')" v-model="form.userName" />
                            <div class="input-group-icon"><i class="fas fa-user"></i></div>
                        </div>
                        <div v-if="isOtpApiCalled && init.userId && checkValidation?.userId?.length > 0" class="thm-error-text">
                            <span v-for="(err, index) in checkValidation?.userId" :key="index">
                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                            </span>
                        </div>
                    </div>
                    <div class="input-field">
                        <div class="input-field-group">
                            <input :type="passwordFieldType" maxlength="20" class="form-control" id="inputPassword4" 
                                @input="form.password = $helper.sanitizeDetails('password', form.password, 20); validate()"
                                :placeholder="$t('enter-password','Enter Password')+'*'" v-model="form.password" />
                            <div class="showHide-icon" @click="togglePasswordVisibility('password')">
                                <i v-if="passwordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                <i v-else aria-hidden="true" class="fa fa-eye"></i>
                            </div>
                        </div>
                        <div v-if="isOtpApiCalled && init.password && checkValidation?.password?.length > 0" class="thm-error-text">
                            <span v-for="(err, index) in checkValidation?.password" :key="index">
                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                            </span>
                        </div>
                    </div>
                    <div class="input-field">
                        <div class="input-field-group">
                            <input :type="confPasswordFieldType" maxlength="20" class="form-control" id="inputPassword5" 
                                @input="form.confirmPassword = $helper.sanitizeDetails('password', form.confirmPassword, 20); validate()"
                                :placeholder="$t('enter-confirm-password','Enter Confirm Password')+'*'" v-model="form.confirmPassword" />
                            <div class="showHide-icon" @click="togglePasswordVisibility('confpassword')">
                                <i v-if="confPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                <i v-else aria-hidden="true" class="fa fa-eye"></i>
                            </div>
                        </div>
                        <div v-if="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmPassword?.length > 0" class="thm-error-text">
                            <span v-for="(err, index) in checkValidation?.confirmPassword" :key="index">
                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                            </span>
                        </div>
                    </div>


                    <div class="refer-code-hyper" v-if ="!isRefral && !hasUrlReferer">
                        <a href="javascript:void(0)" @click="hasUrlReferer =! hasUrlReferer">{{$t('have-a-refferal-code','Have a referral code')}}?</a>
                    </div>
                    
                    <div class="input-field" v-if ="isRefral || hasUrlReferer">
                        <div class="input-field-group">
                            <input type="tel" class="form-control refer-code" @input="form.referCode = $helper.sanitizeDetails('referCode', form.referCode); validate()"
                                :placeholder="$t('refer-code','Enter Referral Code')" v-model="form.referCode" :disabled="isRefral"/>
                            <div class="input-group-icon"><i class="fas fa-share-square"></i></div>
                        </div>
                        <div v-if="init && checkValidation?.referCode?.length > 0" class="thm-error-text">
                            <span v-for="(err, index) in checkValidation?.referCode" :key="index">
                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                            </span>
                        </div>
                    </div>

                    <div class="form-group">
                        <a href="JAvascript:void(0);" class="btn btn-submit btn-login"
                            @click="signUpCall()">
                            {{ $t('register','Register')}}
                            <i class="ml-2 fas fa-sign-in-alt"></i>
                        </a>
                    </div>
                    <div class="whats-app"
                        v-if="$siteSettings?.data?.social_link && $siteSettings?.data?.social_link.whatsappno1">
                        <h3 class="whats-with">
                            <span class="whats-with-now">
                                {{ $t('get-your-ready-made-id-from-whatsapp',"Get your ready-made ID from whatsapp")}}
                            </span>
                        </h3>
                        <div class="button-whatsapp">
                            <button class="btn-whatsapp" @click.prevent="openWhatsApp()">
                                <img loading="lazy" src="@/assets/images/whatsapp.webp" alt="" />
                                <span class="blinking">{{ $t('whatsapp-now',"WhatsApp Now")}}</span></button>
                        </div>
                    </div>

                    <p class="whats-with-acc">{{ $t('already-have-an-account','Already have an account?')}} &nbsp;
                        <router-link :to="{ name: 'Login' }" @click="refreshData">
                            {{ $t('log-in','Login')}}
                        </router-link>
                    </p>
                </form>
            </div>
        </div>
    </section>
</template>

<script>

import commonAuth from '../services/commonAuth';
import validate from '../services/authValidation';

export default {
    name: "SignUp",
    extends: commonAuth,
    data() {
        return {
            form: {
                code: this.$siteSettings.data && this.$siteSettings.data.country_code ? this.$siteSettings.data.country_code : "91",
                mobileNo: "",
                otp: '',
                password: "",
                confirmPassword: "",
                userName: "",
                referCode: this.getQueryParam("refer_code", window.location.href),
            },
            loadingSignUp: false,
            loadingOtp: false,
            hasUrlReferer: false,
            isRefral:false,
            contIndex:null,
            checkCountryCodeSelect:false,
            validationErrors : null,
            isSetUserId: false,

        };
    },
    created() {
        if(this.$siteSettings?.data?.business_type == 1){
            this.$router.push({ name: 'Login' })
        }
        if((window.location.href).includes('refer_code')) {
            this.hasUrlReferer = true;
            this.isRefral = true;
        }  
    },
    computed: {
        countryCodeList(){
            return this.$siteSettings?.data?.country_code_list;
        },
        checkValidation() {
            return this.validationErrors;
        }
    },
    mounted(){
        this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.$siteSettings.data.country_code);
    },
    methods: {
        closeCountryCodeOnOutsideClick(event) {
            const countryCodeElement = this.$refs.countryCodeWrapper;
            if (countryCodeElement && event && event.target && !countryCodeElement.contains(event.target)) {
                this.checkCountryCodeSelect = false;
            }
        },

        openCountryCode(){
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        selectCountryCode(code,phone_code){
            this.contIndex = code;
            this.form.code = parseInt(phone_code)
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'signup',
                this.form.mobileNo,
                this.form.otp,
                this.form.password,
                this.form.confirmPassword,
                this.form.referCode,
                this.form.userName,
            );
            return this.validationErrors;
        },
        otpBtnCall(){
            this.getOTPmsg = true;
            this.toggleInitPhn(true);
            this.validate();
            this.sendOtpCall();
        },
        toggleInitPhn(bool){
            this.init={
                mobile:bool
            }
        },
        toggleInitOTP(bool){
            this.init={
                otp:bool
            }
        },
        toggleInit(bool){
            this.init={
                otp:bool,
                password:bool,
                confirmPassword:bool,
                userId:bool
            }
        },
        formatTime(value) {
            return value < 10 ? `0${value}` : value;
        },
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'password'){
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
            } else {
                this.confPasswordFieldType = this.confPasswordFieldType === 'password' ? 'text' : 'password';
            }
            
        },
        openWhatsApp() {
            window.open(`//wa.me/${this.$siteSettings?.data?.social_link.whatsappno1}`, '_blank');
        },

        signUpCall() {
            if (this.loadingSignUp) {
                return;    
            }
            this.toggleInitPhn(true);
            this.getOTPmsg = true;
            if(this.isOtpApiCalled) {
                this.toggleInitOTP(true);
            }
            if(this.getOtp()?.length){
                this.toggleInit(true)
            }
            if(Object.keys(this.validate())?.filter(key=> key !='referCode').length != 0){
                return;
            }
            if (!this.isOtpApiCalled) {
                this.$errorToast('Call for OTP.');
                return;
            } 
            else {
                this.signUpServiceCall();
            }
        },
        async signUpServiceCall() {
            this.loadingSignUp = true;
            this.$store.dispatch('setGlobalLoader', true);
            let isDownLine = this.getQueryParam("downline", window.location.href);
            let data = {
                "phone": this.form.mobileNo,
                "cncode": this.form.code,
                "password": this.form.password,
                "otp": this.getOtp(),
                "isDownLine": isDownLine ? isDownLine : false,
                "refer_code": this.form.referCode,
                "userid": this.form.userName ? this.form.userName : null, 
            };
            this.$apiCall('post', 'REGISTER', data).then(response => {
                this.loadingSignUp = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200) {
                        if (response.data.status == 0) {
                            this.$errorToast(response.data.message);
                        } else {
                            this.$successToast(response.data.message);
                            this.refreshData();
                            this.$router.push({name: 'Login'})

                        }
                    }
                }
            }).catch(error => {
                this.loadingSignUp = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (error)
                    this.$errorToast(error[0]);
            });
        },
        getQueryParam(paramName, url) {
            if (!url) url = location.href;
            paramName = paramName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + paramName + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results == null ? null : results[1];
        }

    },
};
</script>

<style>
.form-control.refer-code:disabled {
    background-color: #b3b7b5;
}
</style>